// extracted by mini-css-extract-plugin
module.exports = {"title":"styles_title__15xm-","table":"styles_table__1EW_N"};